import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const Loading: React.FC = () => (
    <div className="loading" data-testid="loading">
        <Spinner animation="border" />
    </div>
);

export default Loading;
